@if (shouldShowMenuItem) {
  <div class="menu-item-container" [class.expanded]="appPage.isExpanded">
    @if (externalEndpoint) {
      <a
        #container
        role="menuitem"
        tabindex="0"
        [title]="appPage.displayName"
        [target]="appPage.newTab ? '_blank' : '_self'"
        [href]="externalEndpoint ? appPage.navigationTo : baseUrl + appPage.navigationTo"
        class="menu-item-link"
        [class.parent]="appPage.isParent"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    }

    @if (!externalEndpoint && appPage.isParent) {
      <div class="menu-item-parent" [class.expanded]="appPage.isExpanded" (click)="onExpandToggle()">
        <div class="menu-item-content">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
        <div class="expand-icon">
          @if (appPage.isExpanded) {
            <lucide-icon
              name="chevron-up"
              class="expand-chevron chevron-up"
              [size]="16"
              [strokeWidth]="1.5"
            ></lucide-icon>
          } @else {
            <lucide-icon
              name="chevron-down"
              class="expand-chevron chevron-down"
              [size]="16"
              [strokeWidth]="1.5"
            ></lucide-icon>
          }
        </div>
      </div>
    }

    @if (!externalEndpoint && !appPage.isParent && reactRoute) {
      <a
        #container
        role="menuitem"
        tabindex="0"
        [title]="appPage.displayName"
        [href]="reactNavigationUrl"
        class="menu-item-link"
        [class.selected]="appPage.selected"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    }

    @if (!externalEndpoint && !appPage.isParent && !reactRoute) {
      <a
        #container
        role="menuitem"
        tabindex="0"
        [title]="appPage.displayName"
        [routerLink]="[appPage.navigationTo]"
        [queryParams]="appPage.navigationQuery"
        class="menu-item-link"
        routerLinkActive="router-link-active"
        [routerLinkActiveOptions]="{ exact: appPage.navigationTo === '/app' }"
        [class.selected]="appPage.selected"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    }
    @if (appPage.children && appPage.children.length > 0) {
      <div class="submenu" [class.expanded]="appPage.isExpanded">
        <div class="submenu-separator"></div>
        <div class="submenu-items">
          @for (child of appPage.children; track child.displayName; let i = $index) {
            @if (!child.hidden) {
              @if (isChildExternalEndpoint(child)) {
                <a
                  role="menuitem"
                  tabindex="0"
                  [title]="child.displayName"
                  [href]="child.navigationTo"
                  [target]="child.newTab ? '_blank' : '_self'"
                  class="child-menu-item"
                  [class.selected]="child.selected"
                  [style.transition-delay]="i * 0.02 + 's'"
                >
                  <div class="child-text-container">
                    <div class="child-text">
                      {{ child.displayTitleLabelPath | labelsProvider }}
                    </div>
                  </div>
                </a>
              } @else if (child.isReactRoute) {
                <a
                  role="menuitem"
                  tabindex="0"
                  [title]="child.displayName"
                  [href]="child.navigationTo"
                  class="child-menu-item"
                  [class.selected]="child.selected"
                  [style.transition-delay]="i * 0.02 + 's'"
                >
                  <div class="child-text-container">
                    <div class="child-text">
                      {{ child.displayTitleLabelPath | labelsProvider }}
                    </div>
                  </div>
                </a>
              } @else {
                <a
                  role="menuitem"
                  tabindex="0"
                  [title]="child.displayName"
                  [routerLink]="[child.navigationTo]"
                  [queryParams]="child.navigationQuery"
                  class="child-menu-item"
                  [class.selected]="child.selected"
                  [style.transition-delay]="i * 0.02 + 's'"
                  routerLinkActive="router-link-active"
                  [routerLinkActiveOptions]="{ exact: false }"
                >
                  <div class="child-text-container">
                    <div class="child-text">
                      {{ child.displayTitleLabelPath | labelsProvider }}
                    </div>
                  </div>
                </a>
              }
            }
          }
        </div>
      </div>
    }
  </div>
}

<ng-template #content>
  @if (appPage.iconPath.startsWith('lucide:')) {
    <lucide-icon
      class="menu-item-icon lucide-menu-icon"
      [name]="appPage.iconPath.replace('lucide:', '')"
      [size]="16"
      [strokeWidth]="2"
    >
    </lucide-icon>
  } @else {
    <img class="menu-item-icon" [src]="appPage.iconPath" [alt]="appPage.displayName" />
  }

  <div class="text-container">
    <div class="text" [ngStyle]="{ 'transition-delay': index * 0.02 + 's' }">
      {{ appPage.displayTitleLabelPath | labelsProvider }}
      @if (shouldShowPreviewBadge()) {
        <div class="preview-label">
          <img src="assets/images/notifications/new.svg" class="preview-img" alt="preview" />
          <div>PREVIEW</div>
        </div>
      }
    </div>
  </div>
</ng-template>
